<!--
 * @Author:
 * @Description: 数据校验综合统计
-->
<template>
  <el-card class="h-full" :body-style="{ height: '100%' }">
    <div class="flex">
      <span class="pt-5px">数据标准库：</span>
      <selectStandardId
        :selectStandardProps="selectStandardProps"
        @updateStandardId="updateStandardId"
      />
      <span class="absolute right-20px">数据更新时间：{{ updateTime }}</span>
    </div>
    <el-row class="mt-20px" :gutter="20">
      <el-col class="w-20" v-for="(item, index) in statisticsList" :key="index">
        <el-card class="w-full h-120px">
          <div class="flex">
            <img :src="item.icon" style="width: 64px" />
            <div class="ml-20px pt-20px">
              <p class="text-18px pb-10px">{{ item.title }}</p>
              <p class="text-20px font-bold">{{ item.value }}</p>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div class="mt-20px">
      <el-date-picker
        class="300px"
        v-model="searchTime"
        type="daterange"
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        value-format="yyyy-MM-dd"
      ></el-date-picker>
      <el-button type="primary" class="ml-10px" size="small" @click="searchList">搜索</el-button>
      <el-button
        type="primary"
        class="ml-10px"
        size="small"
        :loading="exportLoading"
        @click="exportData"
        >导出</el-button
      >
    </div>
    <div class="table-wrap mt-20px">
      <el-table height="100%" v-loading="tableLoading" :data="tableData" border>
        <el-table-column label="序号" type="index" width="60">
          <template slot-scope="scope">
            <span>
              {{ scope.$index + 1 + (page.pageNo - 1) * page.pageSize }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in tableHeader"
          :key="index"
          :label="item.label"
          :prop="item.value"
          :width="item.width"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="item.value !== 'createdTime'"> {{ scope.row[item.value] }}% </span>
            <span v-else> {{ scope.row[item.value] }} </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="text-right mt-10px"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
        :current-page.sync="page.pageNo"
        :page-size.sync="page.pageSize"
        :page-sizes="$pageSizeAll"
        @current-change="handleCurrentChange"
        @size-change="searchList"
      >
      </el-pagination>
    </div>
  </el-card>
</template>

<script>
import dataValidationReportService from '@/services/dataValidationReportService'
import fnMixin from '@/assets/js/fnMixins'
import selectStandardId from '../../components/selectStandardId'

export default {
  name: 'comprehensiveStatistics',
  components: {
    selectStandardId,
  },
  mixins: [fnMixin],
  data() {
    return {
      standardId: localStorage.getItem('standardId'),
      selectStandardProps: {
        width: 'w-200px',
      },
      statisticsList: [
        {
          fieldName: 'tagCodeNonConformanceRate',
          icon: require('../../assets/images/show_chart.png'),
          title: '位号编码不合格率',
          value: '0',
        },
        {
          fieldName: 'tagModelAssociationRate',
          icon: require('../../assets/images/histogram.png'),
          title: '位号三维模型关联率',
          value: '0',
        },
        {
          fieldName: 'tagDocumentAssociationRate',
          icon: require('../../assets/images/line_chart.png'),
          title: '位号文档关联率',
          value: '0',
        },
        {
          fieldName: 'documentCodeNonConformanceRate',
          icon: require('../../assets/images/pie_chart.png'),
          title: '文档编码不合规率',
          value: '0',
        },
        {
          fieldName: 'attributeFillingRate',
          icon: require('../../assets/images/area_chart.png'),
          title: '属性总体填充率',
          value: '0',
        },
      ],
      searchTime: '',
      tableHeader: [
        {
          label: '统计时间',
          value: 'createdTime',
        },
        {
          label: '位号编码不合格率',
          value: 'tagCodeNonConformanceRate',
        },
        {
          label: '位号三维模型关联率',
          value: 'tagModelAssociationRate',
        },
        {
          label: '位号文档关联率',
          value: 'tagDocumentAssociationRate',
        },
        {
          label: '文档编码不合规率',
          value: 'documentCodeNonConformanceRate',
        },
        {
          label: '属性总体填充率',
          value: 'attributeFillingRate',
          width: 'createdTime',
        },
      ],
      tableData: [],
      tableLoading: false,
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      exportLoading: false,
      updateTime: '',
    }
  },
  created() {
    this.getSummaryData()
    this.searchList()
  },
  methods: {
    updateStandardId(val) {
      this.standardId = val
      this.getSummaryData()
      this.searchList()
    },
    // 获取统计数据
    async getSummaryData() {
      const res = await dataValidationReportService.getStatisticsTop(this.standardId)
      if (res && res.code === 0) {
        this.updateTime = res.data.createdTime
        this.statisticsList.map((item) => {
          Object.keys(res.data).forEach((val) => {
            if (val === item.fieldName) {
              item.value = `${res.data[val] || 0}%`
            }
          })
          return item
        })
      }
    },
    // 搜索列表
    searchList() {
      this.page.pageNo = 1
      this.getTableData()
    },
    // 获取表格数据
    async getTableData() {
      const params = {
        standardId: this.standardId,
        startTime: (this.searchTime && this.searchTime[0]) || '',
        endTime: (this.searchTime && this.searchTime[1]) || '',
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
      }
      this.tableLoading = true
      const res = await dataValidationReportService.getStatisticsList(params)
      this.tableLoading = false
      if (res && res.code === 0) {
        this.tableData = res.data
        this.page.total = res.totalCount
      }
    },
    handleCurrentChange(val) {
      this.page.pageNo = val
      this.getTableData()
    },
    // 导出
    async exportData() {
      const params = {
        standardId: this.standardId,
        startTime: (this.searchTime && this.searchTime[0]) || '',
        endTime: (this.searchTime && this.searchTime[1]) || '',
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
      }
      this.exportLoading = true
      const res = await dataValidationReportService.getStatisticsExport(params)
      this.exportLoading = false
      if (res) {
        this.downLoadBlob({
          name: '综合统计导出结果.xlsx',
          data: res,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.w-20 {
  width: 20%;
}
.table-wrap {
  height: calc(100% - 290px);
}

</style>
